/**
 * @generated SignedSource<<1beff48a0eb6e65f5090b4aabc0438c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AsanaIntegrationsQuery$variables = {};
export type AsanaIntegrationsQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"AsanaIntegrations_viewer">;
  };
};
export type AsanaIntegrationsQuery = {
  response: AsanaIntegrationsQuery$data;
  variables: AsanaIntegrationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AsanaIntegrationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AsanaIntegrations_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AsanaIntegrationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  {
                    "alias": "hasAccessToAsanaIntegration",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "asana_integration"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"asana_integration\")"
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AsanaUserNode",
                "kind": "LinkedField",
                "name": "asana",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isConnected",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AsanaProjectNode",
                    "kind": "LinkedField",
                    "name": "connectedProject",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "workspaceExternalId",
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "syncEnabled",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includeAiGenerated",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unsyncedActionItemCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "syncedActionItemCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastSyncDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AsanaWorkspaceNode",
                    "kind": "LinkedField",
                    "name": "workspaces",
                    "plural": true,
                    "selections": [
                      (v0/*: any*/),
                      (v1/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserActionItemIntegrationNode",
                "kind": "LinkedField",
                "name": "userLevelActionItemIntegration",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "integrationProvider",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f8a14108b66d7a3615a017df759f583f",
    "id": null,
    "metadata": {},
    "name": "AsanaIntegrationsQuery",
    "operationKind": "query",
    "text": "query AsanaIntegrationsQuery {\n  viewer {\n    ...AsanaIntegrations_viewer\n    id\n  }\n}\n\nfragment AsanaIntegrationAddProjectContent_viewer on Viewer {\n  integrations {\n    asana {\n      workspaces {\n        id\n        externalId\n        name\n      }\n      id\n    }\n  }\n}\n\nfragment AsanaIntegrations_viewer on Viewer {\n  account {\n    billingAccount {\n      hasAccessToAsanaIntegration: hasAccessToFeature(feature: asana_integration)\n      id\n    }\n    id\n  }\n  integrations {\n    asana {\n      id\n      isConnected\n      email\n      connectedProject {\n        id\n        externalId\n        workspaceExternalId\n        name\n        type\n        syncEnabled\n      }\n      includeAiGenerated\n      unsyncedActionItemCount\n      syncedActionItemCount\n      lastSyncDate\n    }\n    userLevelActionItemIntegration {\n      id\n      integrationProvider\n    }\n  }\n  ...AsanaIntegrationAddProjectContent_viewer\n}\n"
  }
};
})();

(node as any).hash = "287b1b0cf6612afd3e02aefacb4b5431";

export default node;
